import {
  CustomizationDataDto,
  TableConfigDto,
} from '@asset-metrix/portal-gateway-client-js';

import { CustomColumnWidths } from './useCustomization';

export function applyCustomizationToColumnConfig(
  columnConfigs: TableConfigDto['columns'],
  customizations: CustomizationDataDto['columns'] = [],
  customColumnWidths: CustomColumnWidths = {}
): TableConfigDto['columns'] {
  return columnConfigs
    .map((columnConfig, columnConfigIndex) => {
      const customizationIndex = customizations.findIndex(
        (c) => c.columnId === columnConfig.id
      );
      const customization =
        customizationIndex !== -1 ? customizations[customizationIndex] : null;

      const hidden =
        columnConfig.hidden ||
        (customization?.visible != null
          ? !customization.visible
          : columnConfig.initiallyUnvisibleToUser);

      return {
        ...columnConfig,
        order:
          customizationIndex !== -1 ? customizationIndex : columnConfigIndex,
        freeze: customization?.fixed ?? columnConfig.freeze,
        initiallyUnvisibleToUser:
          customization?.visible != null
            ? !customization.visible
            : columnConfig.initiallyUnvisibleToUser,
        hidden,
        width:
          customColumnWidths[columnConfig.key]?.width ?? columnConfig.width,
      };
    })
    .sort((a, b) => a.order - b.order)
    .map(({ order, ...c }, idx) => ({ order: idx, ...c }));
}
